export interface BarAndLineChartDataProps {
  category: string;
  barSeriesValue: number;
  lineSeriesValue: number;
}

export enum BarSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}
